"use client";
import "@repo/edtech-ui-kit/styles";
import "@repo/edtech-player-manager/styles";
import { jsxs as l, jsx as n, Fragment as q } from "react/jsx-runtime";
import { useState as ne, useRef as R, useEffect as j, useMemo as ie, useCallback as le } from "react";
import { useClickOutside as ce, useFileSize as ae, isIos as Q, EdtechProvider as de } from "@repo/edtech-shared";
import { PlayerType as c, PlayerFileType as X, SkipIndicator as _e, usePlayerStore as i, usePlayerAllActions as G, getPlayIcon as Z, formatTime as ee, convertBytesToMb as B, PLAYER_SPEED as ue, getVideoSnapshotCached as me } from "@repo/edtech-video-player-utils";
import { OverlayPlayPauseButton as pe, PlayerProgressBar as he, PlayPauseButton as ge, VolumeControl as fe, SettingsButton as ve, FullscreenButton as we, ProgressLine as be, CircularProgress as ke } from "@repo/edtech-ui-kit";
import { ForwardIcon as Ne, ArrowDownAndBracketTrailingIcon as ye, CheckmarkIcon as Ve, PauseIcon as Pe, SmallPlayIcon as Se, CrossIcon as te } from "@repo/edtech-assets";
function se(o) {
  var s, r, t = "";
  if (typeof o == "string" || typeof o == "number") t += o;
  else if (typeof o == "object") if (Array.isArray(o)) {
    var h = o.length;
    for (s = 0; s < h; s++) o[s] && (r = se(o[s])) && (t && (t += " "), t += r);
  } else for (r in o) o[r] && (t && (t += " "), t += r);
  return t;
}
function N() {
  for (var o, s, r = 0, t = "", h = arguments.length; r < h; r++) (o = arguments[r]) && (s = se(o)) && (t && (t += " "), t += s);
  return t;
}
const Ce = () => Math.random().toString(36).slice(2, 9), ze = (o) => {
  if (!o) return null;
  const s = o.indexOf("::");
  return s === -1 ? o : o.slice(0, s);
}, Ie = (o, s, r, t) => o && s ? s : `${r}::${t}`, Ee = (o) => o === c.Video ? "Настройки видео" : "Настройки аудио", Fe = (o) => o === c.Video ? X.Video : X.Audio, Me = "_skip_kh7z7_1", Le = "_skip_right_kh7z7_10", xe = "_skip_left_kh7z7_13", De = "_forward_sec_kh7z7_37", Y = {
  skip: Me,
  skip_right: Le,
  skip_left: xe,
  forward_sec: De
}, $e = ({ skipIndicator: o }) => o && /* @__PURE__ */ l(
  "div",
  {
    className: N(
      Y.skip,
      o === _e.Next ? Y.skip_right : Y.skip_left
    ),
    children: [
      /* @__PURE__ */ n(Ne, {}),
      /* @__PURE__ */ n("span", { className: Y.forward_sec, children: "15 сек." })
    ]
  }
), Re = "_controls_1jfpn_2", je = "_buttons_wrapper_1jfpn_26", Be = "_buttons_1jfpn_26", Ae = "_time_1jfpn_44", Te = "_volume_1jfpn_69", Oe = "_overlay_play_1jfpn_72", L = {
  controls: Re,
  buttons_wrapper: je,
  buttons: Be,
  time: Ae,
  volume: Te,
  overlay_play: Oe
}, Ue = ({
  isLoading: o,
  isControlsActive: s,
  settingsTriggerRef: r,
  handleClick: t
}) => {
  const h = i(c.Video, (e) => e.playing), V = i(c.Video, (e) => e.ended), a = i(c.Video, (e) => e.currentTime), f = i(c.Video, (e) => e.duration), y = i(c.Video, (e) => e.muted), C = i(c.Video, (e) => e.isFullscreen), m = i(c.Video, (e) => e.isShowingControls), z = i(c.Video, (e) => e.currentSkip), v = i(c.Video, (e) => e.playerEl), [p, P] = ne(1), I = R(1), F = s && h, D = s && V, {
    toggleFullscreen: H,
    toggleSettings: J,
    handleControlsPlayButtonClick: $,
    showControlsPermanently: x,
    showControlsForLimitedTime: w,
    seekTo: A,
    toggle: K,
    getPlayerElement: T,
    setMuted: b
  } = G(c.Video), O = () => {
    t(s), s && $();
  };
  j(() => {
    const e = () => {
      document.pictureInPictureElement || w();
    };
    return document.addEventListener("leavepictureinpicture", e), () => {
      document.removeEventListener("leavepictureinpicture", e);
    };
  }, [w]), j(() => {
    if (!v) return;
    const e = () => {
      const g = Number.isFinite(v.volume) ? v.volume : 1;
      P(g), g > 0 && (I.current = g);
    };
    return e(), v.addEventListener("volumechange", e), () => {
      v.removeEventListener("volumechange", e);
    };
  }, [v]);
  const E = (e) => {
    const g = Math.min(1, Math.max(0, e)), S = T();
    if (S) {
      if (S.volume = g, P(g), g === 0) {
        b(!0);
        return;
      }
      I.current = g, y ? b(!1) : S.muted = !1;
    }
  }, U = () => {
    const e = T();
    if (e) {
      if (y || p === 0) {
        const g = I.current > 0 ? I.current : 1;
        e.volume = g, P(g), b(!1);
        return;
      }
      p > 0 && (I.current = p), e.volume = 0, P(0), b(!0);
    }
  }, M = (e) => {
    E(Number(e.target.value));
  };
  return /* @__PURE__ */ l(q, { children: [
    /* @__PURE__ */ n($e, { skipIndicator: z }),
    /* @__PURE__ */ n(
      pe,
      {
        className: L.overlay_play,
        ended: D,
        Icon: Z(F, D),
        isLoading: o,
        isShowingControls: m,
        playing: F,
        onClick: O,
        onMouseLeave: w,
        onMouseMove: x
      }
    ),
    s && (m || !F) && /* @__PURE__ */ l(
      "div",
      {
        className: L.controls,
        onMouseLeave: w,
        onMouseMove: x,
        onTouchMove: w,
        children: [
          /* @__PURE__ */ n(
            he,
            {
              currentTime: a,
              duration: f,
              seekTo: A
            }
          ),
          /* @__PURE__ */ l("div", { className: L.buttons_wrapper, children: [
            /* @__PURE__ */ l("div", { className: L.buttons, children: [
              /* @__PURE__ */ n(
                ge,
                {
                  Icon: Z(F, D),
                  onClick: K
                }
              ),
              /* @__PURE__ */ n(
                fe,
                {
                  className: L.volume,
                  muted: y,
                  volume: p,
                  onChange: M,
                  onToggle: U
                }
              ),
              /* @__PURE__ */ l("span", { className: L.time, children: [
                ee(a),
                " / ",
                ee(f)
              ] })
            ] }),
            /* @__PURE__ */ l("div", { className: L.buttons, children: [
              /* @__PURE__ */ n(
                ve,
                {
                  triggerRef: r,
                  onClick: J
                }
              ),
              /* @__PURE__ */ n(
                we,
                {
                  isFullscreen: C,
                  onClick: H
                }
              )
            ] })
          ] })
        ]
      }
    )
  ] });
}, We = "_download_progress_info_183th_1", Ye = "_info_183th_17", oe = {
  download_progress_info: We,
  info: Ye
}, qe = () => {
  const o = i(
    c.Video,
    (a) => a.downloadedSize
  ), s = i(
    c.Video,
    (a) => a.downloadProgress
  ), r = i(
    c.Video,
    (a) => a.isDownloading
  ), t = i(c.Video, (a) => a.title), h = i(c.Video, (a) => a.fileSize), V = i(c.Video, (a) => a.showSettings);
  return !r || V ? /* @__PURE__ */ n(q, {}) : /* @__PURE__ */ l("div", { className: oe.download_progress_info, children: [
    /* @__PURE__ */ l("div", { className: oe.info, children: [
      /* @__PURE__ */ n("span", { children: t }),
      /* @__PURE__ */ l("span", { children: [
        B(o),
        " из ",
        B(h),
        " МБ"
      ] })
    ] }),
    /* @__PURE__ */ n(be, { percent: s })
  ] });
}, Ge = "_downloader_y5bmg_1", He = "_download_block_y5bmg_7", Je = "_download_y5bmg_1", Ke = "_size_y5bmg_21", Qe = "_progress_y5bmg_27", Xe = "_controls_y5bmg_31", Ze = "_controller_y5bmg_36", eo = "_active_y5bmg_49", oo = "_play_y5bmg_59", no = "_close_icon_y5bmg_65", d = {
  downloader: Ge,
  download_block: He,
  download: Je,
  size: Ke,
  progress: Qe,
  controls: Xe,
  controller: Ze,
  active: eo,
  play: oo,
  close_icon: no
}, to = ({
  url: o,
  fileSize: s,
  fileType: r,
  playerType: t
}) => {
  const h = i(t, (p) => p.downloadProgress), V = i(t, (p) => p.downloadedSize), a = i(t, (p) => p.isDownloading), f = i(t, (p) => p.isPaused), y = i(t, (p) => p.isCompleted), {
    startDownload: C,
    pauseDownload: m,
    cancelDownload: z
  } = G(t), v = () => C(
    o,
    s,
    r
  );
  return /* @__PURE__ */ l("div", { className: d.downloader, children: [
    !a && !f && !y && /* @__PURE__ */ l(
      "button",
      {
        className: N(
          d.download_block,
          d.download,
          d.active
        ),
        onClick: v,
        children: [
          /* @__PURE__ */ n(ye, {}),
          "Скачать",
          " ",
          /* @__PURE__ */ l("span", { className: d.size, children: [
            B(s),
            " МБ"
          ] })
        ]
      }
    ),
    /* @__PURE__ */ l("div", { className: d.download_block, children: [
      y && /* @__PURE__ */ l(q, { children: [
        /* @__PURE__ */ n("button", { className: d.controller, children: /* @__PURE__ */ n(Ve, {}) }),
        /* @__PURE__ */ n("span", { className: d.download, children: "Скачано" })
      ] }),
      (a || f) && /* @__PURE__ */ l(q, { children: [
        /* @__PURE__ */ n(ke, { progress: h }),
        /* @__PURE__ */ l("span", { className: d.download, children: [
          "Скачивание",
          " ",
          /* @__PURE__ */ l("span", { className: d.size, children: [
            B(V),
            " из ",
            B(s),
            " МБ"
          ] })
        ] }),
        /* @__PURE__ */ l("span", { className: d.progress, children: [
          h,
          "%"
        ] })
      ] })
    ] }),
    /* @__PURE__ */ l("div", { className: d.controls, children: [
      a && !f && /* @__PURE__ */ n(
        "button",
        {
          className: d.controller,
          onClick: m,
          children: /* @__PURE__ */ n(Pe, { className: N(d.play, d.active) })
        }
      ),
      f && /* @__PURE__ */ n(
        "button",
        {
          className: d.controller,
          onClick: v,
          children: /* @__PURE__ */ n(Se, { className: d.play })
        }
      ),
      (a || f) && /* @__PURE__ */ n(
        "button",
        {
          className: d.controller,
          onClick: z,
          children: /* @__PURE__ */ n(te, { className: N(d.close_icon, d.active) })
        }
      )
    ] })
  ] });
}, so = "_settings_1rryf_1", ro = "_header_1rryf_17", io = "_close_1rryf_22", lo = "_close_icon_1rryf_31", co = "_settings_title_1rryf_36", ao = "_tools_1rryf_43", _o = "_block_1rryf_49", uo = "_block_title_1rryf_55", mo = "_buttons_1rryf_62", po = "_button_1rryf_62", ho = "_active_1rryf_82", k = {
  settings: so,
  header: ro,
  close: io,
  close_icon: lo,
  settings_title: co,
  tools: ao,
  block: _o,
  block_title: uo,
  buttons: mo,
  button: po,
  active: ho
}, go = ({
  isNeedDownload: o,
  clickOutsideRef: s,
  playerType: r = c.Video,
  onClose: t
}) => {
  const h = i(r, (m) => m.speed), V = i(r, (m) => m.fileSize), a = i(r, (m) => m.source), { setSpeed: f } = G(r), y = Ee(r), C = Fe(r);
  return /* @__PURE__ */ l(
    "div",
    {
      ref: s,
      className: k.settings,
      children: [
        /* @__PURE__ */ l("div", { className: k.header, children: [
          /* @__PURE__ */ n("h2", { className: k.settings_title, children: y }),
          /* @__PURE__ */ n(
            "button",
            {
              className: k.close,
              onClick: t,
              children: /* @__PURE__ */ n(te, { className: k.close_icon })
            }
          )
        ] }),
        /* @__PURE__ */ l("div", { className: k.tools, children: [
          /* @__PURE__ */ l("div", { className: k.block, children: [
            /* @__PURE__ */ n("h3", { className: k.block_title, children: "Скорость" }),
            /* @__PURE__ */ n("div", { className: k.buttons, children: ue.map((m) => /* @__PURE__ */ n(
              "button",
              {
                className: N(k.button, h === m && k.active),
                onClick: () => f(m),
                children: m
              },
              m
            )) })
          ] }),
          o && /* @__PURE__ */ n(
            to,
            {
              fileSize: V ?? 0,
              fileType: C,
              playerType: r,
              url: a
            }
          )
        ] })
      ]
    }
  );
}, fo = "_container_1nd17_1", vo = "_video_wrapper_1nd17_9", wo = "_fullscreen_mode_1nd17_18", bo = "_vertical_mode_1nd17_30", ko = "_preview_1nd17_39", No = "_preview_vertical_1nd17_46", yo = "_hidden_1nd17_52", Vo = "_removed_1nd17_59", Po = "_no_preview_1nd17_63", So = "_pip_placeholder_1nd17_67", Co = "_text_1nd17_74", zo = "_no_border_radius_1nd17_84", u = {
  container: fo,
  video_wrapper: vo,
  fullscreen_mode: wo,
  vertical_mode: bo,
  preview: ko,
  preview_vertical: No,
  hidden: yo,
  removed: Vo,
  no_preview: Po,
  pip_placeholder: So,
  text: Co,
  no_border_radius: zo
}, Ro = ({
  src: o,
  title: s,
  id: r,
  preview: t,
  reuseSlot: h = !0,
  isNeedDownload: V = !0,
  className: a,
  loadingClassname: f,
  withoutBorderRadius: y = !1,
  verticalMode: C = !1
}) => {
  const m = R(Ce()), z = R(null), v = R(null), p = R(null), P = i(c.Video, (_) => _.id), I = i(c.Video, (_) => _.isMini), F = i(c.Video, (_) => _.isLoading), D = i(c.Video, (_) => _.isFullscreen), H = i(c.Video, (_) => _.isMobile), J = i(c.Video, (_) => _.showSettings), {
    setActivate: $,
    setFileSize: x,
    setPlayerWrapEl: w,
    toggleSettings: A,
    showControlsForLimitedTime: K
  } = G(c.Video), T = () => {
    A(), K();
  };
  ce(
    p,
    v,
    H ? () => null : A
  );
  const [b, O] = ne({
    url: null,
    width: 0,
    height: 0,
    loaded: !1
  }), E = !!t, U = h && ze(P) === r, M = ie(() => Ie(
    U,
    P,
    r,
    m.current
  ), [
    U,
    P,
    r
  ]), e = P === M, g = J && e, S = ae(o);
  j(() => {
    if (E || b.url || Q()) return;
    let _ = !1;
    return O({
      url: null,
      width: 0,
      height: 0,
      loaded: !1
    }), me(o).then((W) => {
      _ || O({
        url: W.url,
        width: W.width ?? 0,
        height: W.height ?? 0,
        loaded: !!W.url
      });
    }), () => {
      _ = !0;
    };
  }, [
    o,
    E,
    b.url
  ]);
  const re = le(() => {
    e || ($({
      id: M,
      source: o,
      autoplay: !0,
      title: s
    }), w(z.current));
  }, [
    e,
    $,
    M,
    o,
    s,
    w
  ]);
  return j(() => {
    e && S !== null && !Number.isNaN(S) && x(S);
  }, [
    e,
    S,
    x
  ]), j(() => {
    e && z.current && w(z.current);
  }, [
    e,
    $,
    M,
    o,
    s,
    x,
    S,
    w
  ]), /* @__PURE__ */ n(de, { name: "video-player", children: /* @__PURE__ */ l(
    "div",
    {
      className: N(u.container, a),
      id: "edt-video-player",
      children: [
        /* @__PURE__ */ l(
          "div",
          {
            ref: (_) => {
              z.current = _, e && _ && w(_);
            },
            className: N(
              u.video_wrapper,
              !t && u.no_preview,
              I && e && u.removed,
              D && u.fullscreen_mode,
              (!E && !b.loaded && !Q() || F && e) && f,
              C && u.vertical_mode,
              y && u.no_border_radius
            ),
            "data-video-slot": M,
            children: [
              /* @__PURE__ */ n(
                Ue,
                {
                  handleClick: re,
                  isControlsActive: e,
                  isLoading: !E && !b.loaded && !Q() || F && e,
                  settingsTriggerRef: v
                }
              ),
              /* @__PURE__ */ n(qe, {}),
              E ? /* @__PURE__ */ n(
                "img",
                {
                  alt: "preview",
                  className: N(
                    u.preview,
                    e && u.hidden,
                    C && u.preview_vertical
                  ),
                  src: t
                }
              ) : b.url && /* @__PURE__ */ n(
                "img",
                {
                  alt: "poster",
                  className: N(u.preview, e && u.hidden),
                  rel: "preload",
                  src: b.url
                }
              )
            ]
          }
        ),
        g && /* @__PURE__ */ n(
          go,
          {
            clickOutsideRef: p,
            isNeedDownload: V,
            onClose: T
          }
        ),
        /* @__PURE__ */ l(
          "div",
          {
            className: N(
              u.pip_placeholder,
              u.no_preview,
              (!I || !e) && u.removed
            ),
            children: [
              /* @__PURE__ */ n("span", { className: u.text, children: "Видео воспроизводится в режиме Picture in Picture" }),
              E && /* @__PURE__ */ n(
                "img",
                {
                  alt: "preview",
                  className: N(u.preview, e && u.hidden),
                  src: t
                }
              )
            ]
          }
        )
      ]
    }
  ) });
};
export {
  Ro as EdtechVideoPlayer
};
